module.exports = __webpack_public_path__ + "img/gaijia.5b72f689.png";